import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";
import { Fuses } from "./type";

export const fusesAdaptor = createEntityAdapter<Fuses>({
  selectId: (data) => data._id
})

type FusesInitialState = EntityState<Fuses>

const initialState: FusesInitialState = fusesAdaptor.getInitialState()

export const fusesApiBuilder = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFuses: builder.query<
    EntityState<Fuses>,
    {
      currentSystem: string
      student: string
    }
    >({
      query: (data) =>
        `/fuses/foradmin?currentSystem=${data.currentSystem}&student=${data.student}`,
      transformResponse: (response: any) => {
        return fusesAdaptor.setOne(initialState, response)
      },
      providesTags: ['Fuses']
    })
  })
})

export const { useGetFusesQuery, useLazyGetFusesQuery } = fusesApiBuilder
